(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section-skeleton.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section-skeleton.js');

'use strict';

const {
  Carousel
} = svs.components.lbUi.carousel;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  usePrevious
} = svs.components.lbUtils.usePrevious;
const {
  Skeleton
} = svs.components.lbUi;
const RetailerSectionSkeleton = () => {
  const mobile = useMediaQuery(breakpoints.down(BREAKPOINT_AM)) ? 1 : false;
  const small = useMediaQuery(breakpoints.between(760, 1090)) ? 2 : false;
  const medium = useMediaQuery(breakpoints.between(1090, 1440)) ? 3 : false;
  const large = useMediaQuery(breakpoints.up(1440)) ? 4 : false;
  const itemsPerPage = mobile || small || medium || large;
  const lastPerPage = usePrevious(itemsPerPage);
  const settings = {
    align: mobile ? 'center' : 'start',
    gutter: 1,
    itemsPerPage: itemsPerPage || lastPerPage || 4,
    cardSize: 330,
    useSkeleton: true
  };
  return React.createElement("div", {
    className: "retailer-section retailer-skeletons"
  }, React.createElement("div", {
    className: "retailer-header"
  }, React.createElement("div", {
    className: "retailer-name notranslate"
  }, React.createElement(Skeleton, null)), React.createElement("div", {
    className: "retailer-location"
  }, React.createElement(Skeleton, null)), React.createElement("div", {
    className: "retailer-link"
  }, React.createElement(Skeleton, null))), React.createElement("div", {
    className: "retailer-content"
  }, React.createElement(Carousel, {
    options: settings
  })));
};
setGlobal('svs.components.tipsen.RetailerSectionSkeleton', RetailerSectionSkeleton);

 })(window);